import React, { useState, useEffect } from 'react';
import { timelineApi, TimelineEvent } from '../domains/compliance/api/timeline.api';
import { Sparkles, X, ChevronRight, Award, Shield, FileText, CheckCircle } from 'lucide-react';

const EVENT_ICONS: Record<string, React.ReactNode> = {
  framework_assigned: <Shield className="w-4 h-4 text-sky-500" />,
  certification_issued: <Award className="w-4 h-4 text-emerald-500" />,
  page_certified: <CheckCircle className="w-4 h-4 text-emerald-500" />,
  page_approved_for_audit: <FileText className="w-4 h-4 text-blue-500" />,
};

const WhatsNewBanner: React.FC = () => {
  const [events, setEvents] = useState<TimelineEvent[]>([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const lastDismissed = localStorage.getItem('whats_new_dismissed_at');
    const since = lastDismissed || new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();

    timelineApi.getEvents({ milestone: true, limit: 5, date_from: since.split('T')[0] })
      .then(result => {
        const milestones = (result.events || []).filter((e: TimelineEvent) => e.milestone);
        setEvents(milestones);
      })
      .catch(() => {});
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('whats_new_dismissed_at', new Date().toISOString());
  };

  if (dismissed || events.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-indigo-50 via-blue-50 to-violet-50 border border-indigo-200 rounded-xl p-4 relative">
      <button
        onClick={handleDismiss}
        className="absolute top-3 right-3 p-1 text-slate-400 hover:text-slate-600 hover:bg-white/50 rounded-lg transition-colors"
      >
        <X className="w-4 h-4" />
      </button>

      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0">
          <Sparkles className="w-4 h-4 text-indigo-600" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-indigo-900 mb-2">Recent Milestones</h3>
          <div className="space-y-1.5">
            {events.map((event, idx) => (
              <div key={idx} className="flex items-center gap-2 text-sm">
                {EVENT_ICONS[event.event_type] || <ChevronRight className="w-4 h-4 text-slate-400" />}
                <span className="text-slate-700">{event.event_title}</span>
                <span className="text-xs text-slate-400 ml-auto flex-shrink-0">
                  {new Date(event.event_at || event.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewBanner;
